import { Box, useTheme } from "@mui/material";
import { DisplayOnlyField } from "components/Forms/DisplayOnlyField";
import { MiniModal, useMiniModal } from "components/Forms/MiniModal";
import CopyableTypography from "components/Typography/CopyableTypography";
import { ReactNode, useRef } from "react";

/*
 Renders a display only field wrapped in a gray background container
*/
export const InfoBox = ({
  text,
  label,
  renderValue,
  subtext,
  enablePopover = true,
  transparentBackground,
  infoTooltip,
}: {
  text: string | undefined | null;
  subtext?: string | undefined | null;
  label: string;
  renderValue?: (value: ReactNode) => ReactNode;
  enablePopover?: boolean;
  transparentBackground?: boolean;
  infoTooltip?: ReactNode;
}) => {
  const theme = useTheme();
  const { modalOpen, openModal, closeModal } = useMiniModal(enablePopover);
  const boxRef = useRef<HTMLDivElement>(null);

  return (
    <Box
      ref={boxRef}
      onClick={text ? openModal : undefined}
      sx={{
        backgroundColor: transparentBackground
          ? "transparent"
          : theme.palette.grey50.main,
        px: 2,
        py: 0.5,
        borderRadius: 1,
        height: "100%",
        minHeight: 50,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: text ? "pointer" : "default",
        "&:hover": {
          backgroundColor: transparentBackground
            ? "transparent"
            : theme.palette.grey50.dark,
        },
        "& *": {
          cursor: text ? "pointer !important" : "default",
        },
      }}
    >
      <DisplayOnlyField
        text={text ?? undefined}
        subtext={subtext}
        label={label}
        renderValue={renderValue}
        copyable={false}
        infoTooltip={infoTooltip}
      />

      <MiniModal
        open={modalOpen}
        onClose={closeModal}
        title={label}
        anchorEl={boxRef.current}
      >
        <CopyableTypography
          text={text}
          subtext={subtext}
          sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
        />
      </MiniModal>
    </Box>
  );
};
